<template>
  <div>
    <mdb-card class="mb-4" v-if="error">
      <mdb-card-header>File Folder Contents</mdb-card-header>
      <mdb-card-body>
        <error :error="error"/>
      </mdb-card-body>
    </mdb-card>
    <mdb-card class="mb-4" v-if="folderData">
      <mdb-card-header>{{folderData.title}}</mdb-card-header>
      <mdb-card-body>
        <mdb-list-group>
          <mdb-list-group-item v-bind:key="file.id"
                               v-for="file in folderData.files">

            <a href="" @click.prevent="download(file)">{{file.name}}</a>

          </mdb-list-group-item>
        </mdb-list-group>
      </mdb-card-body>
    </mdb-card>

  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import error from '../common/Error'
import {
  mdbBadge,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbListGroup,
  mdbListGroupItem
} from 'mdbvue';
import download from "js-file-download";

export default {
    name: 'file-folder-section',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbListGroup,
      mdbListGroupItem,
      mdbIcon,
      mdbBadge,
      error
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      section: {
        type: Object,
        default: null
      }

    },
    data() {
      return {
        folderData: null,
        error: null
      };
    },
    mounted() {
      if (!this.group) {
        return
      }
      this.folderData = this.section.data
    },
    methods: {
      async download(file) {
        this.$store.dispatch("setExecuting", true)
        let downloadInfo = await api.getGroupFileLink(file.id, file.accessCode)
        if (!downloadInfo) {
          this.$store.dispatch("setExecuting", false)
          this.$notify.error({message: "File unavailable", timeOut: 4000})
          return
        }
        const response = await fetch(downloadInfo.url)
        const blob = await response.blob()
        download(blob, downloadInfo.fileName)
        this.$store.dispatch("setExecuting", false)

      }
    }
  };
</script>
